import { ErrorCode } from '../enums/error-code';
import { ErrorKey } from '../enums/error-key';

const ERROR_CODE_TO_KEY_MAP: Record<ErrorCode, ErrorKey> = {
  [ErrorCode.UserNotActive]: ErrorKey.UserNotActive,
  [ErrorCode.UserAlreadyExists]: ErrorKey.UserAlreadyExists,
  [ErrorCode.UserAlreadyActive]: ErrorKey.UserAlreadyActive,
  [ErrorCode.UserRegistrationEmailFailed]: ErrorKey.UserRegistrationEmailFailed,
  [ErrorCode.UserActivationEmailFailed]: ErrorKey.UserActivationEmailFailed,
  [ErrorCode.UserResetPasswordEmailFailed]: ErrorKey.UserResetPasswordEmailFailed,
  [ErrorCode.InvalidCredentials]: ErrorKey.InvalidCredentials,
  [ErrorCode.InvalidToken]: ErrorKey.InvalidToken,
  [ErrorCode.ExpiredToken]: ErrorKey.ExpiredToken,
  [ErrorCode.HttpException]: ErrorKey.HttpException,
  [ErrorCode.InternalServerError]: ErrorKey.InternalServerError,
  [ErrorCode.UnknownError]: ErrorKey.UnknownError,
  [ErrorCode.EmailDeliveryFailed]: ErrorKey.EmailDeliveryFailed,
  [ErrorCode.ForeignKeyViolation]: ErrorKey.ForeignKeyViolation,
  [ErrorCode.EntityAlreadyExists]: ErrorKey.EntityAlreadyExists,
  [ErrorCode.RecordNotFound]: ErrorKey.RecordNotFound,
};

export function mapApiError(code: string): ErrorKey {
  if (Object.values(ErrorCode).includes(code as ErrorCode)) {
    return ERROR_CODE_TO_KEY_MAP[code as ErrorCode];
  }

  return ErrorKey.UnknownError;
}
